import PropTypes from 'prop-types';

import Card from '#globalComponents/Card/Card';

import CollectionItemActions, { getRenameAction } from './CollectionItemActions';
import { CollectionItemDate, CollectionItemStats, CollectionItemTags } from './CollectionItemDetails';
import { collectionItemShape } from './collectionItemShape';
import CollectionItemTitle from './CollectionItemTitle';
import { openableProps } from './openableProps';

const CollectionTile = ({ item, isRenaming, onRenameStart, onRenameEnd }) => (
	<Card
		{...openableProps(item.onOpen, isRenaming)}
		className="flex min-h-[200px] cursor-pointer flex-col overflow-hidden p-0 transition-colors hover:border-primary-200"
	>
		<div className="flex items-start gap-2 border-b border-bgBase-500 bg-primary-100 px-3 py-3">
			<div className="min-w-0 flex-1">
				<CollectionItemTitle
					title={item.title}
					isRenaming={isRenaming}
					onRename={item.onRename}
					onRenameEnd={onRenameEnd}
				/>
				<CollectionItemStats stats={item.stats} />
			</div>
			<CollectionItemActions actions={[getRenameAction(item, onRenameStart)]} />
		</div>
		<div className="flex flex-1 flex-col justify-between gap-3 p-3">
			<CollectionItemDate date={item.date} />
			<div className="flex items-center justify-between gap-2">
				<CollectionItemTags tags={item.tags} />
				<CollectionItemActions actions={item.actions ?? []} />
			</div>
		</div>
	</Card>
);

CollectionTile.propTypes = {
	item: collectionItemShape.isRequired,
	isRenaming: PropTypes.bool.isRequired,
	onRenameStart: PropTypes.func.isRequired,
	onRenameEnd: PropTypes.func.isRequired,
};

export default CollectionTile;
